import { useEffect } from 'react';

import { getCookie, setCookie } from 'util/cookies';

const QUERY_PARAMS = {
  irclickid: null,
};

const SetFromQueryParams = () => {
  useEffect(() => {
    const queryParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );

    Object.entries(QUERY_PARAMS).forEach(([key, expires]) => {
      if (getCookie(key)) return;

      if (queryParams[key]) {
        setCookie(key, queryParams[key], { expires });
      }
    });
  }, []);

  return null;
};

export default SetFromQueryParams;
